import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import { PageEvent } from '@angular/material';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { IPageInfo } from '../../../../base/interfaces/IPageInfo';
import { IAnalyticQuery } from '../../interfaces/IAnalyticsQuery';
import { IAnalyticsResult } from '../../interfaces/IAnalyticsResult';
import { AnalyticsService } from '../../services/analytics.service';

export class AnalyticsDataSource<T> implements DataSource<T> {
    private typeSubject = new BehaviorSubject<T[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$ = this.loadingSubject.asObservable();
    
    public pageInfo: IPageInfo = null;
    public pageSizeOptions: number[];
    public pageEvent: PageEvent;
    private filter: object;
    private sort: string;
    private id: string;

    private service: AnalyticsService;
    
    constructor(service: AnalyticsService, id: string, filter?: object, sort?: string, pageSizeOptions?: number[]) {
        this.loadingSubject.next(false);
        this.id = id;
        this.service = service;
        this.filter = filter;
        this.sort = sort;
        this.pageSizeOptions = pageSizeOptions || [20, 50, 100];
    }
   
    connect(collectionViewer: CollectionViewer): Observable<T[] | readonly T[]> {
        this.loadingSubject.next(false);
        return this.typeSubject.asObservable();
    }
    disconnect(): void {
        this.loadingSubject.next(false);
        this.typeSubject.complete();
        this.loadingSubject.complete();
    }
    public loadData = function(query:IAnalyticQuery) {        
        this.loadingSubject.next(true);
        const filterObj = Object.assign({}, this.filter, query.filters);
        let pagesize = query.size;
        let page = query.page;
        this.service.getData(this.id, page, pagesize, filterObj)
        .pipe(
            catchError(() => of([])),
            finalize(() => {
                this.loadingSubject.next(false);
            })
        ).subscribe((type:IAnalyticsResult<any>) => {
            this.pageInfo = type.pageInfo;
            this.typeSubject.next(type.payload);            
        });
    }
    
}